/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type AidModelCalculationRequestGrantCap =
  (typeof AidModelCalculationRequestGrantCap)[keyof typeof AidModelCalculationRequestGrantCap];

export const AidModelCalculationRequestGrantCap = {
  INSTITUTIONAL: 'INSTITUTIONAL',
  NO_GRANT_CAP: 'NO_GRANT_CAP',
  TOTAL_GRANT_CAP: 'TOTAL_GRANT_CAP',
} as const;
